import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useUrlQuery() {
  const { search } = useLocation();

  return queryString.parse(search, { parseBooleans: true });
}
